module.exports = __webpack_public_path__ + "img/pointer.56a38dfa.png";